import { Location } from '@angular/common'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { ESTPipe } from 'src/app/features/shared/pipes/est.pipe'
import { CentralContentService } from 'src/app/services/content/central-content.service'

import { MainService } from '../services/main.service'
import { ProfileService } from '../services/profile/profile.service'
import { YieldsService } from '../services/yields/yields.service'

const REQUEST_PARAM_SPLIT = 1
const DECIMAL_PLACE = 4

@Component({
  selector: 'sec-yield-page',
  templateUrl: './sec-yield-page.component.html',
  styleUrls: ['./sec-yield-page.component.scss'],
})
export class SecYieldPage implements OnInit, OnDestroy {
  aemContentSub?: Subscription
  reitSecYield = ''
  estPipe: ESTPipe = new ESTPipe()
  tickerOrFundId = ''
  UADJYLDRET_PERCENT = '—'
  UADJYLDRET_DATE = '—'
  ADJYLDREIT_PERCENT = '—'
  ADJYLDREIT_DATE = '—'
  fundId = ''
  ticker = ''
  yieldsLoaded: Promise<boolean> | undefined
  isValidTicker = true

  // eslint-disable-next-line max-params
  constructor(
    readonly _location: Location,
    private readonly centralContentService: CentralContentService,
    private readonly yieldsService: YieldsService,
    private readonly mainService: MainService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.tickerOrFundId = this.router.url.split('/')[REQUEST_PARAM_SPLIT]
    this.getAEMContent()
    this.setFundId()
  }

  getAEMContent(): void {
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.reitSecYield =
          this.centralContentService.getContentByBody(
            'disclaimer_reit_yields',
            content,
          ).contentValue || "Sorry, we're having trouble loading this content."
      },
    )
  }

  setFundId(): void {
    this.mainService.getProfileObservable().subscribe({
      next: ({ fundProfile }) => {
        if (fundProfile) {
          this.isValidTicker = true
          this.fundId = fundProfile.fundId
          this.ticker = fundProfile.ticker
          this.setYields()
        } else {
          this.isValidTicker = false
        }
      },
      error: (err) => {
        console.error(err)
      },
    })
  }

  setYields(): void {
    this.yieldsService.getYields(this.fundId).subscribe({
      next: (res) => {
        const yieldData = res.content[0]?.yields || []
        for (const data of yieldData) {
          if (data.yieldCode === 'UADJYLDRET') {
            this.UADJYLDRET_PERCENT = data.percent
            this.UADJYLDRET_DATE = data.effectiveDate
          }
          if (data.yieldCode === 'ADJYLDREIT') {
            this.ADJYLDREIT_PERCENT = data.percent
            this.ADJYLDREIT_DATE = data.effectiveDate
          }
        }
        this.formatContent()
      },
      error: (err) => {
        console.error(err)
      },
    })
  }

  formatContent(): void {
    if (this.UADJYLDRET_PERCENT !== '—') {
      this.UADJYLDRET_PERCENT =
        this.UADJYLDRET_PERCENT.substring(0, DECIMAL_PLACE) + '%'
    }
    if (this.ADJYLDREIT_PERCENT !== '—') {
      this.ADJYLDREIT_PERCENT =
        this.ADJYLDREIT_PERCENT.substring(0, DECIMAL_PLACE) + '%'
    }

    if (this.UADJYLDRET_DATE !== '—') {
      this.UADJYLDRET_DATE = this.estPipe.transform(this.UADJYLDRET_DATE)
    }
    if (this.ADJYLDREIT_DATE !== '—') {
      this.ADJYLDREIT_DATE = this.estPipe.transform(this.ADJYLDREIT_DATE)
    }

    this.reitSecYield = this.reitSecYield.replace(
      'UADJYLDRET_PERCENT',
      `<b>${this.UADJYLDRET_PERCENT}</b>`,
    )
    this.reitSecYield = this.reitSecYield.replace(
      'UADJYLDRET_DATE',
      `<b>${this.UADJYLDRET_DATE}</b>`,
    )
    this.reitSecYield = this.reitSecYield.replace(
      'ADJYLDREIT_PERCENT',
      `<b>${this.ADJYLDREIT_PERCENT}</b>`,
    )
    this.reitSecYield = this.reitSecYield.replace(
      'ADJYLDREIT_DATE',
      `<b>${this.ADJYLDREIT_DATE}</b>`,
    )
  }

  backClicked(): void {
    this._location.back()
    this._location.back()
  }

  ngOnDestroy(): void {
    this.aemContentSub?.unsubscribe()
  }
}
